// src/lib/analytics/track-path-event.ts
//
// Send one learning-path event from the browser, straight to the same ingest
// route the root tracker batches into. Straight rather than queued because the
// two that matter most fire right before navigation (checkpoint_start on the
// click, lesson_complete just before leaving) — `keepalive` lets the request
// outlive the page. Best-effort and silent: analytics must never be a reason a
// student's action fails.

import { getAnonId } from './anon-id'
import type { PathEventType } from './user-event'

export const INGEST_URL = '/api/events/ingest'

export function trackPathEvent(type: PathEventType, label: string, path?: string): void {
  try {
    const at = path ?? (typeof location !== 'undefined' ? location.pathname : '/')
    const payload = JSON.stringify({
      anonId: getAnonId(),
      events: [{ type, path: at, label }],
    })
    void fetch(INGEST_URL, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: payload,
    }).catch(() => {})
  } catch {
    // never throw into the app
  }
}
